import React from 'react';

export const AdultsOnlyCunnilingusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M50.5 31.2C53.1731 31.2 55.34 29.0331 55.34 26.36C55.34 23.687 53.1731 21.52 50.5 21.52C47.827 21.52 45.66 23.687 45.66 26.36C45.66 29.0331 47.827 31.2 50.5 31.2Z"
        fill="#FF6AA0"
      />
      <path
        d="M3.59999 50.12C6.09999 48.92 9.75999 48.06 11.54 46.38C11.84 46.08 11.78 45.88 11.78 45.74C11.78 44.14 11.62 42.4 11.66 40.2C11.62 34.48 18.42 31.98 22.96 32.46C26.58 32.64 29.9 33.54 33 35.34C33.42 35.58 33.56 36.1 33.32 36.52C33.2 36.74 33 36.86 32.78 36.92C28.34 38.42 23.86 38.76 20.04 40.48C19.62 40.68 19.42 40.92 19.46 40.9C19.48 40.92 19.68 40.5 19.62 40.5C19.44 43.02 19.6 46.52 17.8 49.2C14.4 53.98 8.03999 52.8 3.61999 50.94C3.27999 50.8 3.27999 50.28 3.61999 50.14L3.59999 50.12Z"
        fill="#00A6ED"
      />
      <path
        d="M44.04 43.0999C43.86 43.2599 43.68 43.3999 43.5 43.4799C43.3 43.5199 43.12 43.2199 43.06 43.0799C41.7 40.3199 39.26 38.1399 36.52 37.2999C36.78 36.7799 37.16 36.2799 37.62 35.8799C39.62 34.0999 42.68 34.2799 44.44 36.2799C46.22 38.2799 46.04 41.3399 44.04 43.0999Z"
        fill="#00A6ED"
      />
      <path
        d="M55.16 33.3601C58.64 43.9201 43.08 60.3401 35.08 47.2601C34.7 46.6601 34.32 46.1401 34.04 45.8801C33.76 45.6001 33.78 45.4001 33.3 45.5801C30.56 46.8001 27.8 50.0601 25.1 52.1201C24.72 52.4201 24.18 52.3601 23.88 51.9801C23.36 49.7801 24.54 47.3801 25.26 45.2601C28.64 36.8001 37.5 34.8601 42.24 43.6401C42.8 44.5601 43 44.7001 44.24 44.3001C48.54 42.3601 52.62 38.2201 54.4 33.4201C54.46 33.0201 55.06 32.9601 55.2 33.3601H55.16Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
